import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AlignItemsBottom = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M1 13.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 0-1h-13a.5.5 0 0 0-.5.5ZM6.5 11H3V3h3.5v8ZM3 12a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3Zm6.5-1H13V7H9.5v4Zm-1 0a1 1 0 0 0 1 1H13a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4Z"
          clipRule="evenodd"
        />
      </svg>
    )
  },
)

export default AlignItemsBottom
